// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import WZList from "./components/WZList";
import WZCreate from "./components/WZCreate";
import AdminDashboard from "./components/AdminDashboard";
import Login from "./components/Login";
import NavigationBar from "./components/NavigationBar";
import ProtectedRoute from "./components/ProtectedRoute";
import VehicleDashboard from "./components/vehicles/VehicleDashboard";
import VehicleList from "./components/vehicles/VehicleList";
import VehicleDetail from "./components/vehicles/VehicleDetail";
import RepairsList from "./components/vehicles/RepairsList";
import ServicesList from "./components/vehicles/ServicesList";
import VehicleRepairHistory from "./components/vehicles/VehicleRepairHistory";
import VehicleServiceHistory from "./components/vehicles/VehicleServiceHistory";
import FaultReportForm from "./components/vehicles/FaultReportForm";
import WorkshopManagerPanel from "./components/vehicles/WorkshopManagerPanel";
import VehicleStatistics from "./components/vehicles/VehicleStatistics";
import VehicleSettings from "./components/vehicles/VehicleSettings";
import WZStatistics from "./components/WZStatistics";
import { AuthContext } from "./context/AuthContext";
import "./styles.css";
// import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/primereact.min.css"; 
import "primeicons/primeicons.css";
import { useEffect, useContext } from "react";
import { addLocale, locale } from "primereact/api";

addLocale("pl", {
  firstDayOfWeek: 1,
  dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
  dayNamesShort: ["Ndz", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
  dayNamesMin: ["N", "P", "W", "Ś", "C", "P", "S"],
  monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
  monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
  today: "Dziś",
  clear: "Wyczyść",
  dateFormat: "dd.mm.yy",
  weekHeader: "Tydz",
});
locale("pl");

// Wrapper that checks permission before rendering
const PermGuard = ({ perm, children }) => {
  const { hasPermission, getFirstPermittedPath } = useContext(AuthContext);
  if (!hasPermission(perm)) return <Navigate to={getFirstPermittedPath()} replace />;
  return children;
};

function App() {
  useEffect(() => {
    const ratio = window.devicePixelRatio; // np. 1.25 przy 125% skali
    if (ratio > 1) {
      console.log("Skalowanie: ", document.documentElement);
    }
  }, []);
  return (
    <Router>
      <div className="container">
        <NavigationBar />
        <main>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Trasy zabezpieczone – dostępne tylko dla zalogowanych użytkowników */}
            <Route element={<ProtectedRoute />}>
              {/* Dashboard – strona główna po zalogowaniu */}
              <Route path="/" element={<Dashboard />} />
              {/* Panel WZ / RW */}
              <Route path="/dokumenty" element={<PermGuard perm="docs_list"><WZList /></PermGuard>} />
              <Route path="/dokumenty/nowy" element={<PermGuard perm="docs_create"><WZCreate /></PermGuard>} />
              <Route path="/dokumenty/statystyki" element={<PermGuard perm="docs_stats"><WZStatistics /></PermGuard>} />
              {/* Panel administracyjny */}
              <Route path="/admin" element={<PermGuard perm="admin_panel"><AdminDashboard /></PermGuard>} />
              {/* Pojazdy */}
              <Route path="/pojazdy" element={<PermGuard perm="vehicles_dashboard"><VehicleDashboard /></PermGuard>} />
              <Route path="/pojazdy/lista" element={<PermGuard perm="vehicles_list"><VehicleList /></PermGuard>} />
              <Route path="/pojazdy/:id" element={<PermGuard perm="vehicles_list"><VehicleDetail /></PermGuard>} />
              <Route path="/naprawy" element={<PermGuard perm="vehicles_repairs"><RepairsList /></PermGuard>} />
              <Route path="/naprawy/pojazd/:id" element={<PermGuard perm="vehicles_repairs"><VehicleRepairHistory /></PermGuard>} />
              <Route path="/serwisy" element={<PermGuard perm="vehicles_services"><ServicesList /></PermGuard>} />
              <Route path="/serwisy/pojazd/:id" element={<PermGuard perm="vehicles_services"><VehicleServiceHistory /></PermGuard>} />
              <Route path="/zgloszenia" element={<PermGuard perm="vehicles_faults"><FaultReportForm /></PermGuard>} />
              <Route path="/warsztat" element={<PermGuard perm="vehicles_workshop"><WorkshopManagerPanel /></PermGuard>} />
              <Route path="/statystyki" element={<PermGuard perm="vehicles_statistics"><VehicleStatistics /></PermGuard>} />
              <Route path="/ustawienia-pojazdow" element={<PermGuard perm="vehicles_settings"><VehicleSettings /></PermGuard>} />
            </Route>
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
